<template>
    <div class="clients-table">
        <div class="clients-table__header">
            <h4 class="clients-table__title">{{ textContent.list }}</h4>
            <v-btn
                color="#967adc"
                small
                dark
                @click="addClient"
                data-test-id="clients--add-client-btn"
            >
                <i class="icon-plus-small"></i>
                <span class="clients-table__btn-text">{{
                    textContent['add-client']
                }}</span>
            </v-btn>
        </div>
        <!--        <div v-if="!isMobile" class="clients-table__actions">-->
        <!--            <p>{{ textContent.show }}</p>-->
        <!--            <div class="clients-table__counter">-->
        <!--                <select-->
        <!--                    v-model="countToShow"-->
        <!--                    class="clients-table__counter-select"-->
        <!--                >-->
        <!--                    <option v-for="item in counts" :key="item" :value="item">-->
        <!--                        {{ item }}-->
        <!--                    </option>-->
        <!--                </select>-->
        <!--                <i class="icon-select-arrows"></i>-->
        <!--            </div>-->
        <!--            <p>{{ textContent.items }}</p>-->
        <!--        </div>-->
        <div class="clients-table__table">
            <v-data-table
                calculate-widths
                mobile-breakpoint="767"
                :headers="headers"
                :page="page"
                :items="clientsToVisible"
                :hide-default-footer="true"
                :items-per-page-options="counts"
                :items-per-page="itemPerPage"
                :items-per-page-text="textContent['clients-per-page']"
                :server-items-length="total"
                @page-count="pageCount = $event"
                @click:row="contextHandle"
            ></v-data-table>
            <v-pagination
                :value="page"
                :length="pageCount"
                :total-visible="7"
                color="#3bafda"
                @input="paginationHandle"
            ></v-pagination>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { actionTypes } from '@/store/modules/modals'

import popUpTypes from '@/types/pop-up-types'
import phoneNumberView from '@/helpers/phone-number-view'
import languageMixin from '@/mixins/language.mixin'
import { format } from 'date-fns'
import { FULL_DATE_FORMAT } from '@/consts'
import parseDateIntoIsoString from '@/helpers/parse-date-into-iso-string'

const { clientUpdate } = popUpTypes

export default {
    name: 'ClientsTable',
    mixins: [languageMixin],
    props: {
        clients: {
            type: Array,
            default: () => [],
        },
        page: {
            type: Number,
            default: 1,
        },
        itemPerPage: {
            type: Number,
            default: 15,
        },
        total: {
            type: Number,
            default: 0,
        },
    },
    emits: ['context-handle', 'add-client', 'change-page-handle'],
    data() {
        return {
            windowWidth: window.innerWidth,
            pageCount: 0,
            counts: [15, 30, 50, 100],
            countToShow: 15,
        }
    },
    computed: {
        isMobile: function () {
            return this.windowWidth < 768
        },
        clientsToVisible: function () {
            return this.clients.map((client) => {
                const createdAt = format(
                    parseDateIntoIsoString(client.created_at),
                    FULL_DATE_FORMAT
                )
                return {
                    ...client,
                    phone: phoneNumberView(client.phone),
                    createdAt,
                }
            })
        },
        headers: function () {
            return [
                { text: 'Created At', value: 'createdAt' },
                { text: this.textContent?.name, value: 'full_name' },
                {
                    text: this.textContent?.phone,
                    value: 'phone',
                    width: '25%',
                },
            ]
        },
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize)
        })
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions('modals', { onOpen: actionTypes.openPopUp }),
        contextHandle: function ({ id }) {
            this.$emit('context-handle', id)
        },
        addClient: function () {
            this.onOpen(clientUpdate)
        },
        onResize() {
            this.windowWidth = window.innerWidth
        },
        paginationHandle: function (page) {
            if (this.page === page) {
                return
            }

            this.$emit('change-page-handle', page)
        },
    },
}
</script>

<style scoped lang="scss">
.clients-table {
    &__header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;

        @include tablet-up {
            margin-bottom: 0;
        }
    }

    &__actions {
        display: flex;
        align-items: center;
        margin-top: 35px;
        font-size: 14px;
    }

    &__counter {
        margin: 0 10px;
        position: relative;

        i {
            position: absolute;
            top: 50%;
            right: 7px;
            transform: translateY(-50%);
        }
    }

    &__counter-select {
        font-size: 12px;
        padding: 10px 24px 10px 10px;
        border: 1px solid rgba(0, 0, 0, 0.35);
        border-radius: 4px;
        outline: none;
        transition: all 150ms ease-in-out;

        &:focus {
            border: 1px solid #3bafda;
        }
    }

    &__title {
        font-weight: 500;
    }

    &__btn-text {
        text-transform: none;
    }
}

.table {
    margin-top: 15px;
    width: 100%;
    table-layout: fixed;
    border: 1px solid #000;
    border-collapse: collapse;
    color: #55595c;
    font-size: 15px;

    th,
    td {
        border: 1px solid #e3ebf3;
        padding: 5px 0 5px 25px;
    }

    &__header {
        border-bottom: 3px solid #e3ebf3;
    }

    &__row {
        &--title {
            width: 300px;
        }
    }

    &__column {
        text-align: left;

        &--name {
        }

        &--phone {
            width: 25%;
            min-width: 135px;
        }
    }
}
</style>
